import { type ContentImageContainerProps } from "@client/content/controls/Image/container";
import { getImageStyle } from "@client/lib/image";
import * as React from "react";

import "./style.less";

export type ImageExtraAttributes = {
  fetchPriority?: "high" | "auto";
  loading?: "lazy";
};
export type ImageProps = ContentImageContainerProps & ImageExtraAttributes;
const ContentImage = (props: ImageProps) => (
  <span className="wsc_content_image_container">
    <img
      className={props.className}
      fetchPriority={props.fetchPriority}
      loading={props.loading}
      src={props.src}
      style={getImageStyle(props.size, props.style, props.isFixedSize)}
      alt={props.alt || ""}
    />
  </span>
);
export default ContentImage;
